import emailjs from '@emailjs/browser';

// EmailJS Configuration
// These should be set up in the EmailJS dashboard
const SERVICE_ID = 'service_macheteman';
const APPROVAL_TEMPLATE_ID = 'template_approval';
const ORDER_TEMPLATE_ID = 'template_order';
const PUBLIC_KEY = 'YOUR_PUBLIC_KEY'; // Replace with actual key from EmailJS dashboard

// Initialize EmailJS
emailjs.init(PUBLIC_KEY);

interface ApprovalEmailParams {
  to_email: string;
  to_name: string;
  business_name: string;
  temp_password: string;
}

interface OrderConfirmationParams {
  to_email: string;
  to_name: string;
  order_number: string;
  order_total: string;
  items_summary: string;
}

interface OrderStatusUpdateParams {
  to_email: string;
  to_name: string;
  order_number: string;
  new_status: string;
  tracking_number?: string;
}

export const sendApprovalEmail = async (params: ApprovalEmailParams): Promise<void> => {
  try {
    await emailjs.send(SERVICE_ID, APPROVAL_TEMPLATE_ID, {
      to_email: params.to_email,
      to_name: params.to_name,
      business_name: params.business_name,
      temp_password: params.temp_password,
      login_url: `${window.location.origin}/admin`,
      support_email: 'info@themacheteman.com'
    });
    console.log('Approval email sent successfully');
  } catch (error) {
    console.error('Failed to send approval email:', error);
    throw new Error('Failed to send approval email. Please try again.');
  }
};

export const sendOrderConfirmation = async (params: OrderConfirmationParams): Promise<void> => {
  try {
    await emailjs.send(SERVICE_ID, ORDER_TEMPLATE_ID, {
      to_email: params.to_email,
      to_name: params.to_name,
      order_number: params.order_number,
      order_total: params.order_total,
      items_summary: params.items_summary,
      payment_email: 'payments@themacheteman.ca',
      support_email: 'info@themacheteman.com'
    });
    console.log('Order confirmation email sent successfully');
  } catch (error) {
    console.error('Failed to send order confirmation email:', error);
    throw new Error('Failed to send order confirmation email.');
  }
};

export const sendOrderStatusUpdate = async (params: OrderStatusUpdateParams): Promise<void> => {
  const statusMessages: Record<string, string> = {
    'payment_received': 'We have received your payment and your order is being processed.',
    'processing': 'Your order is being prepared for shipment.',
    'shipped': `Your order has been shipped!${params.tracking_number ? ` Tracking number: ${params.tracking_number}` : ''}`,
    'delivered': 'Your order has been delivered. Thank you for your business!'
  };

  try {
    await emailjs.send(SERVICE_ID, 'template_status_update', {
      to_email: params.to_email,
      to_name: params.to_name,
      order_number: params.order_number,
      status_message: statusMessages[params.new_status] || `Order status updated to: ${params.new_status}`,
      tracking_number: params.tracking_number || '',
      support_email: 'info@themacheteman.com'
    });
    console.log('Order status update email sent successfully');
  } catch (error) {
    console.error('Failed to send status update email:', error);
    // Don't throw - status updates are not critical
  }
};
